import { put } from 'redux-saga/effects';
import { change } from 'redux-form';
import { uploadFile, uploadVideo } from '../../api/fileUploadAPI';
import * as types from './fileActionTypes';

export function* fileUploadSaga({ file, seasonId, formName, fieldName, fileType }) {
  try {
    let uploadedFile;
    if (fileType === 'video') {
      uploadedFile = yield uploadVideo(file, seasonId);
    } else {
      uploadedFile = yield uploadFile(file, seasonId);
    }
    if (uploadedFile && uploadedFile.error) {
      yield put({
        type: types.UPLOAD_FILE_ERROR,
        error: uploadedFile.error,
      });
    } else {
      yield put({
        type: types.UPLOAD_FILE_SUCCESS,
      });
      yield put(change(formName, `${fieldName}Id`, uploadedFile.public_id));
      yield put(change(formName, `${fieldName}Format`, uploadedFile.format));
      yield put(change(formName, fieldName, uploadedFile.secure_url));
    }
  } catch (error) {
    yield put({
      type: types.UPLOAD_FILE_ERROR,
      error,
    });
  }
}



// WEBPACK FOOTER //
// ./src/store/file/fileSaga.js